<template>
  <div class="container">
    <div class="mb-5 mt-5 d-flex justify-content-center">
      <img alt="Logo" class="align-self-center" src="@/assets/bos.png" height="100" />
    </div>
    <b-row align-h="center">
      <b-col class="col-xxxl-4" xl="5" lg="6" md="8">
        <h1 class="display-4 block-title mb-4 text-center">BOŠ Partneri</h1>
        <b-alert
          dismissible
          variant="danger"
          v-model="unauthorized"
        >Uneti email i lozinka nisu pronađeni.</b-alert>
        <b-alert
          dismissible
          variant="danger"
          v-model="network_error"
        >Greška u komunikaciji sa serverom.</b-alert>
        <b-form @submit="doLogin">
          <b-form-group label-size="sm" laber-for="email" label="Email">
            <b-input-group>
              <b-input-group-prepend is-text>
                <b-icon icon="person-fill"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                id="email"
                size="lg"
                v-model="credentials.username"
                trim
                autofocus
                required
                placeholder
              ></b-form-input>
            </b-input-group>
          </b-form-group>

          <b-form-group label-size="sm" laber-for="password" label="Lozinka">
            <b-input-group>
              <b-input-group-prepend is-text>
                <b-icon icon="lock-fill"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                id="password"
                type="password"
                size="lg"
                v-model="credentials.password"
                trim
                required
                placeholder
              ></b-form-input>
            </b-input-group>
          </b-form-group>

          <b-button
            block
            type="submit"
            variant="primary"
            size="md"
            class="btn btn-lg text-white mt-5"
            @click.prevent="doLogin"
          >
            <b-spinner v-if="isLoading" class="mr-1" small label="Sending..." />
            <span v-else>Pošalji</span>
          </b-button>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      unauthorized: false,
      network_error: false,
      isLoading: false,
      credentials: {
        username: "",
        password: ""
      }
    };
  },
  computed: {
    buttonDisabled: () => {
      return true;
    }
  },
  methods: {
    doLogin() {
      this.isLoading = true;
      this.$store
        .dispatch("auth/login", this.credentials)
        .then(() => {
          this.$router.push({ name: "home" });
        })
        .catch(err => {
          this.isLoading = false;
          if (!err.response) {
            this.makeToast(
              "danger",
              "Server error",
              "Server nije odgovorio na zahtev."
            );
          } else {
            if (err.response.status == 422) {
              this.unauthorized = true;
            }
          }

          //console.log(err);
        });
    }
  }
};
</script>

<style scoped>
</style>